module.exports = __webpack_public_path__ + "static/media/scopio.8ae4a321.png";